export const enum EventName {
    /** 展示充值按钮 */
    ShowRechargeButton = 'Show_Recharge_Button',
    /** 点击充值按钮 */
    ClickRechargeButton = 'Click_Recharge_Button',
    /** 展示充值弹窗 */
    ShowRechargeModal = 'Show_Recharge_Modal',
    /** 选择充值金额 */
    SelectRechargeAmount = 'Select_Recharge_Amount',
    /** 点击支付按钮 */
    ClickPayButton = 'Click_Pay_Button',
    /** 提交支付行为 */
    SubmitPayAction = 'Submit_Pay_Action',
    /** 展示登录弹窗 */
    ShowLoginModal = 'Show_Login_Modal',
    /** 点击登录弹窗按钮 */
    ClickLoginModalButton = 'Click_Login_Modal_Button',
    /** 提交登录表单 */
    SubmitLoginForm = 'Submit_Login_Form',
    /** 展示邀请按钮 */
    ShowInviteButton = 'Show_Invite_Button',
    /** 点击邀请按钮 */
    ClickInviteButton = 'Click_Invite_Button',
}

export const enum LoginModalPosition {
    Register = 'register',
    Login = 'login',
    LoginAndRegister = 'login_and_register',
    OneClickLogin = 'one_click_login',
    RetryOneClickLoginNetwork = 'retry_one_click_login_network',
    Tab = 'tab'
}

export const enum InviteButtonPosition {
    InviteCode = 'invite-code',
    InviteLink = 'invite-link',
}
